<template>
  <div class="page_content module_course" aria-label="Course About Page Content">
    <course-header :course-id="course.uuid" :can-edit="true" class="header_course_about"></course-header>
    <div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">

      <div class="col-3 thumbnail_panel">
        <div class="thumbnail_container d-flex ace_sec_txt">
          <div v-if="course.thumbnail" class="d-flex align-items-center justify-content-center">
            <img class="w-100" v-bind:src="course.thumbnail" alt="Img">
          </div>
          <div v-else class="default">
            <div class="thumbnail">
              <div class="thumbnail_icon icon-course"></div>
            </div>
          </div>
        </div>
        <template v-if="isExternalCourse">
          <div class="white-wrapper mb-4 py-3">
            <div class="page_section_row row pl-4 mb-2 ace_sec_txt">
              <div class="heading col-auto px-1">Release Date - </div>
              <div class="value col-auto pl-1 details">{{course.releaseDate}}</div>
            </div>
          </div>
          <div class="white-wrapper mb-4 py-3">
            <div class="page_section_row row pl-4 mb-2 ace_sec_txt">
              <div class="heading col-auto px-1">Level - </div>
              <div class="value col-auto pl-1 details">{{course.level}}</div>
            </div>
          </div>
        </template>
        <div class="white-wrapper mb-4 py-3">
          <div class="page_section_row row pl-4 mb-2 ace_sec_txt" :aria-label="course.maxCredit + ' credits'">
            <template v-if="isExternalCourse">
              <div class="heading col-auto px-1">Duration - </div>
              <div class="value col-auto pl-1 details">{{course.duration}} </div>
            </template>
            <template v-else>
              <div class="heading col-auto px-1"># of {{creditLabel}}s - </div>
              <div class="value col-auto pl-1">{{course.maxCredit}} </div>
            </template>
          </div>
          <div class="page_section_row row pl-4 mb-2">
            <template v-if="!isOpenCourse">
              <div class="heading col-auto px-1 ace_sec_txt" v-if="isStudentLogin" :aria-label="mcSummary.childrenCount + ' Micro Competencies'"># of Micro Competencies - <span class="details">{{mcSummary.childrenCount }}</span></div>
              <div class="heading col-auto px-1 ace_sec_txt" v-else :aria-label="mcCount + ' Micro Competencies'"># of Micro Competencies - <span class="details">{{mcCount}}</span></div>
            </template>
            <div class="value col-auto pl-1"></div>
          </div>
        </div>
        <template v-if="!course.master">
          <div class="white-wrapper mb-4 py-3">
            <div class="page_section_row row pl-4 mb-2">
              <template v-if="isExternalCourse">
                <div class="heading col-auto px-1">Author - </div>
                <div class="value col-auto pl-1 details">{{course.author}} </div>
              </template>
              <template v-else>
                <div class="heading col-auto px-1 ace_sec_txt">Instructor - <span class="details">{{instructorName}}</span></div>
              </template>
              <div class="value col-auto pl-1 "></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="course.roomInformation">
              <div class="heading col-auto px-1 ace_sec_txt">Location - <span class="details" >{{course.roomInformation}} </span></div>
              <div class="value col-auto pl-1"></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="meetingDays" >
              <div class="heading col-auto px-1 ace_sec_txt">Meeting Days - <span class="details" >{{meetingDays}} </span></div>
              <div class="value col-auto pl-1"></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="meetingTimes" >
              <div class="heading col-auto px-1 ace_sec_txt">Meeting Times - <span class="details" >{{meetingTimes}} </span></div>
              <div class="value col-auto pl-1"></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="crn" >
              <div class="heading col-auto px-1 ace_sec_txt">CRN - <span class="details" >{{crn}} </span></div>
              <div class="value col-auto pl-1"></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="section" >
              <div class="heading col-auto px-1 ace_sec_txt">Section # - <span class="details">{{section}} </span></div>
              <div class="value col-auto pl-1"></div>
            </div>
            <div class="page_section_row row pl-4 mb-2" v-if="course.catalogCourseId">
              <div class="heading col-auto px-1 ace_sec_txt">
                Catalog Course -
                <b-link :to="{ name: 'catalogDetail', params: { uuid: course.catalogCourseId } }">{{course.title}}</b-link>
              </div>
              <div class="value col-auto pl-1"></div>
            </div>
          </div>
        </template>
      </div>
      <div class="col-7 left-spacer">
        <div class="page-section">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Course Description</label>
            </div>
            <div class="value page_content_block ">
              <div class="courseDesc">
                <div class="course-desc-content ace_sec_txt">

                  <div class="custom_container_course_about">
                    <div v-html="course.description"></div>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="course.description">
              <a href="javascript:void(0)" class="more-btn more-desc float-right mt-1" @click="showAll" aria-label="read more">more</a>
            </div>
            <b-modal id="courseDescription" class="custom_modal course_description" size="lg" centered hide-footer>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Course Description</div>
                <button class="btn_close" aria-label="close" @click="closeshowAll">
                <span class="ic-close"></span>
                </button>
              </div>
              <div class="course-desc-content" v-html="course.description"></div>
            </b-modal>
          </div>
          <div class="page_section_row description min-content" v-if="course.courseType">
            <div class="heading">
              <label class="ace_sec_txt">Course Type</label>
            </div>
            <div class="value page_content_block">
              <div class="course-desc-content ace_sec_txt">{{ getCourseTypeLabel(course.courseType) }}</div>
            </div>
          </div>
          <div class="page_section_row description min-content" v-if="course.courseType">
            <div class="heading">
              <label class="ace_sec_txt">Course Catalog External ID</label>
            </div>
            <div class="value page_content_block">
              <div class="course-desc-content ace_sec_txt">{{ course.catalogCourseExternalId }}</div>
            </div>
          </div>

          <div class="page_section_row description min-content" v-if="isSisIntegrationEnable">
            <div class="heading">
              <label class="ace_sec_txt">SIS Integration </label>
            </div>
            <div class="value page_content_block">
                <div class="row">
                  <div class="col-3">
                    <label class="ace_sec_txt">SIS Course ID:  {{ course.sisCourseId }} </label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt">SIS Course Section ID:  {{ course.sisCourseSectionId }}</label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt" v-if="course.maxSeats > 0 ">Max Seats :  {{ course.maxSeats }} / Enrolled : {{ course.currentSeats }} </label>
                    <label class="ace_sec_txt" v-else>Max Seats : N/A </label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt">Term: {{ course.termCode }} </label>
                  </div>

                </div>
            </div>
          </div>

          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">LMS Integration </label>
            </div>
            <div class="value page_content_block">
                <div class="row">
                  <div class="col-3">
                    <label class="ace_sec_txt">LMS Course ID:  {{ course.lmsCourseCourseId }} </label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt">LMS Section ID:  {{ course.lmsCourseId }}</label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt">SSO Enabled: {{ course.enableSSO }}</label>
                  </div>
                  <div class="col-3">
                    <label class="ace_sec_txt">LTI 1.3 Enabled: {{ course.ltiCourse }}</label>
                  </div>
                </div>
            </div>
          </div>
          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Observation Deadline </label>
            </div>
            <div class="value page_content_block">
                <div class="row">
                  <div class="col-4">
                    <label class="ace_sec_txt" v-if="course.showDeadLine">Show Deadline: Enabled</label>
                    <label class="ace_sec_txt" v-else>Show Deadline: Disabled</label>
                  </div>
                  <div class="col-4">
                    <label class="ace_sec_txt" v-if="course.duration && course.duration=='Select One'">Duration:   N/A </label>
                    <label class="ace_sec_txt" v-else>Duration:   {{ course.duration }}</label>
                  </div>
                </div>
            </div>
          </div>
          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Additional Settings</label>
            </div>
            <div class="value page_content_block">
                <div class="row">
                  <div class="col-3">
                    <label class="ace_sec_txt" >State : </label>
                    <label class="ace_sec_txt" v-if="course.archived">Archived</label>
                    <label class="ace_sec_txt" v-else>Active</label>
                  </div>
                  <div class="col-3" v-if="isSectionChannelEnabled">
                    <label class="ace_sec_txt" >Channel : </label>
                    <label class="ace_sec_txt" v-if="course.createChannel">Enabled</label>
                    <label class="ace_sec_txt" v-else>Disabled</label>
                  </div>
                  <div class="col-6" v-if="institution.sendItemAnalysisReport">
                    <label class="ace_sec_txt" >Send Item Analysis Report : </label>
                    <label class="ace_sec_txt" v-if="course.sendItemAnalysisReportCourse">Enabled</label>
                    <label class="ace_sec_txt" v-else>Disabled</label>
                  </div>
                </div>
            </div>
          </div>

          <div class="page_section_row">
          <div class="heading">
                <label>Score to Students</label>
          </div>
          <div class="value page_content_block">
                <div v-if="course.hideScoreForStudent">Disabled (Hidden)</div>
                <div v-else>Enabled (Visible)</div>
              </div>
          </div>

          <div class="page_section_row">
          <div class="heading">
                <label>Automatically Validate Resource Links</label>
          </div>
          <div class="value page_content_block">
                <div v-if="course.checkBrokenLinks">Enabled</div>
                <div v-else>Disabled</div>
              </div>
          </div>
          <div class="page_section_row" v-if="isLLMContentEnabled">
          <div class="heading">
                <label>Pragya AI</label>
          </div>
          <div class="value page_content_block" v-if="isLLMContentEnabled">
                <div v-if="course.supportAIContent">LLM content enabled</div>
                <div v-else>LLM content disabled</div>
              </div>
          </div>
           <div class="page_section_row">
                <div class="heading">
                  <label class="ace_sec_txt">Include Topic in course flow</label>
                </div>
                <div class="page_content_block">
                  <div class="row">
                    <div class="col-3">
                      <label class="ace_sec_txt" v-if="course.includeCDesc">Description: Enabled</label>
                      <label class="ace_sec_txt" v-else>Description: Disabled</label>
                    </div>
                    <div class="col-3">
                      <label class="ace_sec_txt" v-if="course.includeCAI">AI Content: Enabled</label>
                      <label class="ace_sec_txt" v-else>AI Content: Disabled</label>                     
                    </div>
                    <div class="col-3">
                      <label class="ace_sec_txt" v-if="course.includePreMessage">Pre Message: Enabled</label>
                      <label class="ace_sec_txt" v-else>Pre Message: Disabled</label>                     
                    </div>
                    <div class="col-3">
                      <label class="ace_sec_txt" v-if="course.includePostMessage">Post Message: Enabled</label>
                      <label class="ace_sec_txt" v-else>Post Message: Disabled</label>                     
                    </div>

                  </div>
                </div>
          </div>
           <div class="page_section_row">
                <div class="heading">
                  <label class="ace_sec_txt">Course Dashboard Settings</label>
                </div>
                <div class="page_content_block">
                  <div class="row">
                    <div class="col-6">
                      <label class="ace_sec_txt" v-if="course.showProgress">Show Progress: Enabled</label>
                      <label class="ace_sec_txt" v-else>Show Progress: Disabled</label>
                    </div>
                    <div class="col-6">
                      <label class="ace_sec_txt" v-if="course.showAnnouncements">Show Announcements: Enabled</label>
                      <label class="ace_sec_txt" v-else>Show Announcements: Disabled</label>                     
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label class="ace_sec_txt" v-if="course.menuToInstructor">Show Menu To Instructor: Enabled</label>
                      <label class="ace_sec_txt" v-else>Show Menu To Instructor: Disabled</label>
                    </div>
                    <div class="col-6">
                      <label class="ace_sec_txt" v-if="course.showAnnouncements">Show Announcements: Enabled</label>
                      <label class="ace_sec_txt" v-else>Show Announcements: Disabled</label>                     
                    </div>
                  </div>

                </div>
          </div>

          <div class="page_section_row clo clo-content" v-if="isMCReady">
            <div class="heading">
              <label class="ace_sec_txt">Competencies</label>
            </div>
            <div class="value page_content_block">
              <div class="clo-section">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <div id="mc-popup" class="mc-popup"></div>
                  <template v-for="mc in microcompetencies">
                    <span class="clo-box ace_sec_txt" :id="mc.code" :title="mc.code" v-bind:aria-label="mc.code">{{mc.code}}</span>
                    <b-popover :target="mc.code" :content="mc.description" container="mc-popup" v-bind:aria-label="mc.code" triggers="hover focus"></b-popover>
                  </template>
                </div>
              </div>
            </div>
            <div>
              <a href="javascript:void(0)" class="more-link show-more float-right mt-1" @click="expandCollapseClo" style="display:none;">more</a>
              <a href="javascript:void(0)" class="more-link show-less float-right mt-1" @click="expandCollapseClo" style="display:none;">less</a>
            </div>
          </div>
          <!-- skills -->
          <div class="page_section_row tag-sec tag-content" v-if="skills && skills.length > 0">
            <div class="heading">
              <label class="ace_sec_txt">Skills</label>
            </div>
            <div class="value page_content_block">
              <div class="tag-section">
                <div class="tag-container">
                  <div class="icon-container">
                    <span class="icon ic-tag"></span>
                  </div>
                  <div class="tags-row tags_container">
                    <span class="tag" v-for="tag in skills" :title="tag.name" :aria-label="tag.name">
                      <span class="tag_name competency_tag ace_sec_txt"> {{ tag.name }} </span>
                    </span>
                    <span class="tag-box ellipsisTags ace_sec_txt" @click="showSkillTags">
                      <span class="fa fa-ellipsis-h"> </span>
                    </span>
                  </div>
                  <!--
                  <div class="no-tags-row">
                    <div class="w-100 no_tags">
                    </div>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </div>
          <b-modal id="courseSkillTagsPopup" size="lg" centered :title="'Skills'">
            <div class="tags-section">
              <div class="value">
                <div class="tag-box-list tags_container">
                  <span class="tag" v-for="tag in skills">
                  <span class="tag_name instructional_tag"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
            <div slot="modal-header" class="header-section">
              <div class="popup-heading">Skills</div>
              <button class="btn_close" aria-label="close" @click="closeSkillTags">
              <span class="ic-close"></span>
              </button>
            </div>
            <div class="footer-section" slot="modal-footer">
              <b-button type="button" class="btn button-primary mr-3" @click="closeSkillTags"> ok </b-button>
            </div>
          </b-modal>
          <!-- tags -->
          <div class="page_section_row tag-sec tag-content" v-if="tags && tags.length > 0">
            <div class="heading">
              <label class="ace_sec_txt">Tags</label>
            </div>
            <div class="value page_content_block">
              <div class="tag-section">
                <div class="tag-container">
                  <div class="icon-container">
                    <span class="icon ic-tag"></span>
                  </div>
                  <div class="tags-row tags_container">
                    <span class="tag" v-for="tag in tags" :title="tag.name" :aria-label="tag.name">
                      <span class="tag_name instructional_tag ace_sec_txt"> {{ tag.name }} </span>
                    </span>
                    <span class="tag-box ellipsisTags ace_sec_txt" @click="showTags">
                      <span class="fa fa-ellipsis-h"> </span>
                    </span>
                  </div>
                  <!--
                  <div class="no-tags-row">
                    <div class="w-100 no_tags">
                    </div>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </div>
          <b-modal id="courseTagsPopup" size="lg" centered :title="'Tags'">
            <div class="tags-section">
              <div class="value">
                <div class="tag-box-list tags_container">
                  <span class="tag" v-for="tag in tags">
                  <span class="tag_name instructional_tag"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
            <div slot="modal-header" class="header-section">
              <div class="popup-heading">Tags</div>
              <button class="btn_close" aria-label="close" @click="closeTags">
              <span class="ic-close"></span>
              </button>
            </div>
            <div class="footer-section" slot="modal-footer">
              <b-button type="button" class="btn button-primary mr-3" @click="closeTags"> ok </b-button>
            </div>
          </b-modal>
          <template v-if="!course.master">
            <div class="page_section_row credits-section">
              <template v-if="isExternalCourse">
                <!--
                  <div class="heading">
                    <label class="ace_sec_txt">Course URL</label>
                  </div>
                  -->
                <div class="page_content_block">
                  <div class="row">
                    <div class="col-8">
                      <b-button :href="generateLtiLink()" target="_blank" class="title">Launch Lynda Course</b-button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="heading">
                  <label class="ace_sec_txt">{{creditLabel}}s</label>
                </div>
                <div class="page_content_block">
                  <div class="row">
                    <div class="col-4">
                      <label class="ace_sec_txt">Min {{creditLabel}}: </label>
                      <div class="course-desc-content ace_sec_txt">{{ course.minCredit }}</div>
                    </div>
                    <div class="col-4">
                      <label class="ace_sec_txt">Max {{creditLabel}}: </label>
                      <div class="course-desc-content ace_sec_txt">{{ course.maxCredit }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="page_section_row description min-content" v-if="course.startDate">
              <div class="heading">
                <label class="ace_sec_txt">Start Date</label>
              </div>
              <div class="value page_content_block">
                <div class="course-desc-content ace_sec_txt">{{ changeDateFormat(course.startDate) }}</div>
              </div>
            </div>
            <div class="page_section_row description min-content" v-if="course.endDate">
              <div class="heading">
                <label class="ace_sec_txt">End Date</label>
              </div>
              <div class="value page_content_block">
                <div class="course-desc-content ace_sec_txt">{{ changeDateFormat(course.endDate) }}</div>
              </div>
            </div>

          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/module/css/course/courseAbout.min.css'
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'course-detail',
  props: ['uuid', 'loadDataFromServer'],
  components: {
    CourseHeader,
    CourseNav
  },
  data: () => {
    return {
      tags: [],
      skills: [],
      isMCReady: false,
      isStudentLogin: (localStorage.getItem('userrole') === 'Student'),
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },

  mounted () {
    this.$store.commit('LOAD_COURSE_MICROCOMPETENCIES', [])
    this.loadCourse()
  },

  updated () {
    this.showMore()
    this.showMoreLess()
    this.showMoreTags()
    let self = this
    this.$nextTick(function () {
      window.addEventListener('resize', function (e) {
        self.showMore()
        self.showMoreLess()
        self.showMoreTags()
      })
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadMicroCompetencies',
      'loadCourseTopics',
      'loadLogDashboardActivity'
    ]),

    loadCourse () {
      this.loadLogDashboardActivity({action: 'viewCourseAbout', page: 'courseDetail', link: '', entityUuid: this.uuid})
      this.loadCourseDetailFromServer(this.uuid).then(res => {
        this.populateSkillsAndTags(this.course)
        if (this.course.competencies[0]) {
          this.loadMicroCompetencies(this.course.competencies[0]).then(respons => {
            this.isMCReady = true
          })
        }
      })
      // this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true}).then(res => {
      // })
    },

    populateSkillsAndTags (entity) {
      let appliedTagMap = entity.appliedTagMap
      if (appliedTagMap) {
        let tagEntries = Object.entries(appliedTagMap)
        if (tagEntries && tagEntries.length > 0) {
          for (const [key, values] of tagEntries) {
            if (key) {
              values.forEach(value => {
                this.tags.push(value)
              })
            }
          }
        }
      }
      let careerCompetenciesMap = entity.careerCompetenciesMap
      if (careerCompetenciesMap) {
        let skillEntries = Object.entries(careerCompetenciesMap)
        if (skillEntries && skillEntries.length > 0) {
          for (const [key, values] of skillEntries) {
            if (key) {
              values.forEach(value => {
                this.skills.push(value)
              })
            }
          }
        } else {
          this.skills = entity.careerCompetenciesList
        }
      } else {
        this.skills = entity.careerCompetenciesList
      }
    },

    competencyPopover () {
      $('.clo-box').mouseover(function () {
        $('body').addClass('competency-popover')
      })
    },

    closeCompetencyPopover () {
      $('.clo-box').mouseleave(function () {
        $('body').removeClass('competency-popover')
      })
    },

    expandCollapseClo () {
      if ($('.clo').hasClass('clo-content')) {
        $('.clo').toggleClass('expandClo', 500)
      }
    },

    showMoreLess () {
      var paragraphHeight = $('p, .course-desc-content').height()
      if (paragraphHeight > 137) {
        $('.more-desc').show()
        $('.less-desc').hide()
      } else {
        $('.less-desc').hide()
        $('.more-desc').hide()
      }
      if (paragraphHeight <= 137) {
        $('.more-desc, .less-desc').hide()
        $('.description').removeClass('expand', 500)
      }
    },

    showAll () {
      this.$root.$emit('bv::show::modal', 'courseDescription')
    },

    closeshowAll () {
      this.$root.$emit('bv::hide::modal', 'courseDescription')
    },

    expandCollapseDescription () {
      if ($('.description').hasClass('min-content')) {
        $('.description').toggleClass('expand', 500)
      }
    },

    showMore () {
      let height = $('.clo-container').innerHeight()
      if (height > 100) {
        $('.show-more').show()
        $('.show-less').hide()
      } else {
        $('.show-more, .show-less').hide()
      }
    },

    showMoreTags () {
      let height = $('.tags-row').innerHeight()
      if (height > 68) {
        $('.ellipsisTags').show()
      } else {
        $('.ellipsisTags').hide()
      }
    },

    showTags () {
      this.$root.$emit('bv::show::modal', 'courseTagsPopup')
    },

    closeTags () {
      this.$root.$emit('bv::hide::modal', 'courseTagsPopup')
    },

    showSkillTags () {
      this.$root.$emit('bv::show::modal', 'courseSkillTagsPopup')
    },

    closeSkillTags () {
      this.$root.$emit('bv::hide::modal', 'courseSkillTagsPopup')
    },

    changeDateFormat (selected) {
      if (selected && selected.length > 0) {
        const mm = selected.slice(0, 2)
        const dd = selected.slice(2, 4)
        const yyyy = selected.slice(4)
        const formatted = mm + '/' + dd + '/' + yyyy
        const date = new Date(formatted)
        return dd + ' ' + this.months[date.getMonth()] + ' ' + yyyy
      }
      return selected
    },

    getCourseTypeLabel (courseType) {
      if (courseType === 'SUGGESTION_SUPPLEMENT_BASED' || courseType === 'SUGGESTION_PLUS_BASED' || courseType === 'SUGGESTION_BASED') {
        return 'Problem Based Learning'
      } else if (courseType === 'BASIC') {
        return 'Competency Based Learning'
      } else {
        return 'Topic Based Learning'
      }
    },

    generateLtiLink () {
      let courseType = this.course.courseType
      if (courseType && courseType.includes('LYNDA')) {
        let externalId = this.course.externalId
        if (externalId) {
          let courseId = this.course.uuid
          let origin = window.location.origin
          let token = localStorage.getItem('token')
          let lyndaCourseId = externalId.split('_')[1]
          let lyndaLtiLaunchUrl = origin + '/toolProxy/lyndaCourseLaunch/' + courseId + '/' + lyndaCourseId + '?token=' + token
          return lyndaLtiLaunchUrl
        }
      }
      return (this.course.courseURL || 'javascript://')
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'mcSummary': state => state.course.mcSummary,
      'microcompetencies': state => state.course.microcompetencies,
      'topics': state => state.course.topics,
      'isTocOpen': state => state.course.isTocOpen,
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),

    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    isSisIntegrationEnable () {
      let sisIntegrationFeature = this.enabledFeatures['sis_integration']
      return sisIntegrationFeature && sisIntegrationFeature.enabled
    },
    isLLMContentEnabled (){
      let contentToolsFeature = this.enabledFeatures['Content Tools']
      if (contentToolsFeature) {
        let flags = contentToolsFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Enable LLM content') {
            return flags[i].enabled
          }
        }
      }
      return false
    },    
    isSectionChannelEnabled() {
      let channelFeature = this.enabledFeatures['channels']
      if (channelFeature) {
        let flags = channelFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Enable course section channel') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    instructorName: function () {
      if (this.course.instructorNames) {
        var str = this.course.instructorNames[0]
        var res = str.split('__')
        var instNames = res[0]
        for (var i = 1; i < this.course.instructorNames.length; i++) {
          str = this.course.instructorNames[i]
          res = str.split('__')
          instNames = instNames + ', ' + res[0]
        }
        return instNames
      } else {
        return ''
      }
    },

    mcCount: function () {
      var count = 0
      if (this.topics) {
        for (var i = 0; i < this.topics.length; i++) {
          if (this.topics[i]) {
            count = count + this.topics[i].subtopics.length
          }
        }
      }
      return count
    },

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      } else {
        return false
      }
    },

    isExternalCourse () {
      if (this.course && this.course.courseType && this.course.courseType.includes('EXTERNAL_')) {
        return true
      } else {
        return false
      }
    },

    meetingDays () {
      var meetingDays = ''
      if (this.course.meetingDaysRaw && this.course.meetingDaysRaw.length > 0) {
        meetingDays = meetingDays + this.course.meetingDaysRaw[0].day
      }

      if (this.course.meetingDaysRaw && this.course.meetingDaysRaw.length > 1) {
        meetingDays = meetingDays + ', ' + this.course.meetingDaysRaw[1].day
      }
      return meetingDays
    },
    meetingTimes () {
      var meetingTimes = ''
      if (this.course.meetingDaysRaw && this.course.meetingDaysRaw.length > 0) {
        if (this.course.meetingDaysRaw[0].meetingFromTime !== null && this.course.meetingDaysRaw[0].meetingToTime !== null) {
          meetingTimes = meetingTimes + this.course.meetingDaysRaw[0].meetingFromTime + '-' + this.course.meetingDaysRaw[0].meetingToTime
        }
      }

      if (this.course.meetingDaysRaw && this.course.meetingDaysRaw.length > 1) {
        if (this.course.meetingDaysRaw[1].meetingFromTime !== null && this.course.meetingDaysRaw[1].meetingToTime !== null) {
          meetingTimes = meetingTimes + ', ' + this.course.meetingDaysRaw[1].meetingFromTime + '-' + this.course.meetingDaysRaw[1].meetingToTime
        }
      }
      return meetingTimes
    },

    crn () {
      if (this.course.crn) {
        return this.course.crn
      } else {
        return ''
      }
    },

    section () {
      if (this.course.num) {
        return this.course.num
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>

<style>
.icon-container {
	width: 30px;
    height: 38px;
    float: left;
    position: relative;
}
.icon-container .ic-tag {
	font-size: 32px;
	position: absolute;
	margin-left: 0px;
	margin-top: 5px;
}

.clo-container {
	width: 92%;
	width: -moz-calc(100% - 48px);
    width: -webkit-calc(100% - 48px);
    width: -o-calc(100% - 48px);
    width: calc(100% - 48px);
	float: left;
	margin-left: 18px;
	margin-top: -4px;
}
.clo-container .clo-box {
	padding: 6px 12px;
  color: #fff;
  margin-bottom: 6px;
	margin-top: 6px;
  margin-right: 18px;
  float: left;
  width: 114px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseDetail.vue